import { useSelector } from 'react-redux';
import { selectUser } from '../store/features/auth/authSlice';
import { hasPermission, type Permission } from '../lib/permissions';

/**
 * Returns true if the currently authenticated user has the given permission.
 * Always returns false when unauthenticated.
 */
export function usePermission(permission: Permission): boolean {
  const user = useSelector(selectUser);
  return hasPermission(user, permission);
}
